var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({class:_vm.computedLinkClasses,on:{"click":function($event){return _vm.$emit('nav-link-click')}}},'a',_vm.linkProps,false),[_vm._t("default",null,{"isActive":_vm.isActive})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }